export default {
    NESTE_MUNICIPIO: 1,
    EM_OUTRO_MUNICIPIO: 2,
    EM_OUTRO_PAIS: 3,
}